/**
 * The left menu keeps the last book while a refetch clears it.
 * The projects list is the intentional All stories screen.
 */
export function heldMenuIdentity({
  onProjectsHome = false,
  currentProject = null,
  currentStory = null,
  heldProject = null,
  heldStory = null,
} = {}) {
  if (onProjectsHome) {
    return {
      project: null,
      story: null,
      nextHeldProject: null,
      nextHeldStory: null,
    };
  }
  const project = currentProject || heldProject || null;
  const story = currentStory || heldStory || null;
  return {
    project,
    story,
    nextHeldProject: project,
    nextHeldStory: story,
  };
}
